import React from "react";

function Terms() {
    return (
        <div style={styles.container}>
            <h1>Terms and Conditions</h1>

            <p>
                By using Scan4Help, you agree to the following terms and conditions.
            </p>

            <h3>Service Description</h3>
            <p>
                Scan4Help provides a platform that allows users to register emergency
                contact details and access them via QR codes.
            </p>

            <h3>User Responsibility</h3>
            <p>
                Users are responsible for providing accurate and up-to-date information.
                Scan4Help is not responsible for incorrect or outdated data.
            </p>

            <h3>Usage</h3>
            <p>
                This service is intended for safety and emergency purposes only. Misuse
                of the platform is strictly prohibited.
            </p>

            <h3>Limitation of Liability</h3>
            <p>
                Scan4Help is not liable for any direct or indirect damages arising from
                the use of the service.
            </p>

            <h3>Changes to Terms</h3>
            <p>
                We may update these terms at any time. Continued use of the service
                indicates acceptance of the updated terms.
            </p>

            <h3>Contact</h3>
            <p>
                For any queries, contact us at support@scan4help.app
            </p>

            <p style={styles.footer}>Last updated: {new Date().toLocaleDateString()}</p>
        </div>
    );
}

const styles = {
    container: {
        maxWidth: "800px",
        margin: "auto",
        padding: "20px",
        lineHeight: "1.6",
        fontFamily: "Arial"
    },
    footer: {
        marginTop: "20px",
        fontSize: "12px",
        color: "gray"
    }
};

export default Terms;